module.exports = __webpack_public_path__ + "static/img/service1.e146e1f5.jpg";